import { useParams } from 'react-router-dom'

import { DeleteParticipantsModal } from 'modules/trainings/components/Revamp/TrainingsDetail/TrainingEmployeesDataTable/DeleteParticipantsModal'

const DeleteParticipant = () => {
  const { membershipId } = useParams()

  return <DeleteParticipantsModal membershipIds={[Number(membershipId)]} />
}

export default DeleteParticipant
